var BitConditionModel = /** @class */ (function () {
    function BitConditionModel(variableName, variableGroupName, bitConditionLogic, dataSourceCode, isBitwiseIndex, bitIndex, dataType, variableVersion) {
        this.variableName = variableName;
        this.variableGroupName = variableGroupName;
        this.bitConditionLogic = bitConditionLogic;
        this.dataSourceCode = dataSourceCode;
        this.isBitwiseIndex = isBitwiseIndex;
        this.bitIndex = bitIndex;
        this.dataType = dataType;
        this.variableVersion = variableVersion;
    }
    return BitConditionModel;
}());
export { BitConditionModel };
